var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkShoppingSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14_377)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 12,
    fill: "#3C373A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 11.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 11.6875C14.2917 12.3333 15.0833 12.6562 16 12.6562C16.9167 12.6562 17.6979 12.3333 18.3438 11.6875C19.0104 11.0417 19.3438 10.2604 19.3438 9.34375H18C18 9.88542 17.8021 10.3542 17.4062 10.75C17.0104 11.1458 16.5417 11.3438 16 11.3438C15.4583 11.3438 14.9896 11.1458 14.5938 10.75C14.1979 10.3542 14 9.88542 14 9.34375H12.6562C12.6562 10.2604 12.9792 11.0417 13.625 11.6875ZM17.4062 6.59375C17.0104 6.19792 16.5417 6 16 6C15.4583 6 14.9896 6.19792 14.5938 6.59375C14.1979 6.98958 14 7.45833 14 8H18C18 7.45833 17.8021 6.98958 17.4062 6.59375ZM20.6562 8C21.0104 8 21.3229 8.13542 21.5938 8.40625C21.8646 8.67708 22 8.98958 22 9.34375V17.3438C22 17.6979 21.8646 18.0104 21.5938 18.2812C21.3229 18.5312 21.0104 18.6562 20.6562 18.6562H11.3438C10.9896 18.6562 10.6771 18.5312 10.4062 18.2812C10.1354 18.0104 10 17.6979 10 17.3438V9.34375C10 8.98958 10.1354 8.67708 10.4062 8.40625C10.6771 8.13542 10.9896 8 11.3438 8H12.6562C12.6562 7.08333 12.9792 6.30208 13.625 5.65625C14.2917 4.98958 15.0833 4.65625 16 4.65625C16.9167 4.65625 17.6979 4.98958 18.3438 5.65625C19.0104 6.30208 19.3438 7.08333 19.3438 8H20.6562Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14_377",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_377"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_377",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkShoppingSmall);
export default __webpack_public_path__ + "static/media/mark-shopping-small.f9d5a3b425a9bbad40d2bad8bb2d96b3.svg";
export { ForwardRef as ReactComponent };